import { render, staticRenderFns } from "./user-over-time.vue?vue&type=template&id=4b2dcfa7&scoped=true&"
import script from "./user-over-time.vue?vue&type=script&lang=ts&"
export * from "./user-over-time.vue?vue&type=script&lang=ts&"
import style0 from "./user-over-time.vue?vue&type=style&index=0&id=4b2dcfa7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2dcfa7",
  null
  
)

export default component.exports